import env from "../utils/env";
import { createAbortableFetcher, prepareHyHttpHeaders } from "../utils/http";

export const createInsuranceProvidersFetcher = () => {
  const [doFetch] = createAbortableFetcher(
    `${env("BASE_HY_URL")}insurance/payers/search`,
    {
      headers: prepareHyHttpHeaders()
    }
  );
  return name => doFetch({ name });
};
